import { useAxios } from "@/hooks";
import { endPoint } from "@/utils";
import React from "react";
import { toast } from "react-hot-toast";


interface SubmitParams {
  values: Record<string, unknown>;
  resetForm: () => void;
}

export const useContactForm = () => {
  const { fetchData } = useAxios();
  const [submitted, setSubmitted] = React.useState(false);

  const handleSubmit = async ({ values, resetForm }: SubmitParams) => {
    const response = await fetchData({
      url: endPoint.POST_CONTACT_FORM,
      method: "POST",
      data: values,
    });

    if (response?.data) {
      setSubmitted(true);
      resetForm();
      toast.success("Form Submitted Successfully!");
      return;
    }

    toast.error(response?.message ?? "Something went wrong.");
  };

  return {
    submitted,
    handleSubmit,
  };
};
